import React, { useState } from 'react'
import { Modal, Stack } from '~/components/_layouts'
import { UserIcon } from '@heroicons/react/24/outline'
import { useCandidate } from './CandidateProvider'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../lib/ui/select'
import { Button } from '../../lib/ui/button'

const candidateStatusOptions = {
  active: 'Active Search',
  paused: 'Paused',
  landed: 'Landed',
}

const CandidateStatusDialog = () => {
  const {
    showCandidateStatusDialog,
    toggleShowCandidateStatusDialog,
    candidateStatus,
    setNewCandidateStatus,
  } = useCandidate()

  const [formValue, setFormValue] = useState('')

  return (
    <Modal
      title={
        <Stack direction="row" spacing={2}>
          <UserIcon className="h-6 w-6" />
          Candidate Program Status
        </Stack>
      }
      size="md"
      open={showCandidateStatusDialog}
      onClose={() => toggleShowCandidateStatusDialog()}
    >
      <div className="text-center">
        Candidates are in an active state unless they have a need to pause their
        program or have landed in a new role. You can update candidate state
        using the dropdown below. If a candidate is moved into a landed state,
        you will not be able to move them back into an active search state.
      </div>
      <div className="flex justify-center">
        <Select
          onValueChange={(v) => setFormValue(v)}
          defaultValue={
            Object.entries(candidateStatusOptions).find(
              ([, value]) => value === candidateStatus,
            )?.[0] || ''
          }
        >
          <SelectTrigger className="sm:w-4/6">
            <SelectValue placeholder="Select an option" />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(candidateStatusOptions).map(([key, value]) => (
              <SelectItem key={key} value={key}>
                {value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="mt-4 flex justify-center">
        <Button onClick={() => setNewCandidateStatus(formValue)}>Save</Button>
      </div>
    </Modal>
  )
}

export default CandidateStatusDialog
